import { generateNumberRange } from '~/lib/utils';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import type { SearchConditions } from '~/types/search-conditions';

interface AnnualSalaryFormProps {
  searchConditions: SearchConditions;
  setSearchConditions: (searchConditions: SearchConditions) => void;
}

export function AnnualSalaryForm(props: AnnualSalaryFormProps) {
  const salaryOptions = generateNumberRange(200, 1200, 100).map((salary) => ({
    label: `${salary}万円`,
    value: salary.toString(),
  }));

  // 下限表示用のラベル生成
  const getMinLabel = () => {
    if (props.searchConditions.annualSalaryMin == null) return '下限なし';
    return `${props.searchConditions.annualSalaryMin}万円`;
  };

  // 上限表示用のラベル生成
  const getMaxLabel = () => {
    if (props.searchConditions.annualSalaryMax == null) return '上限なし';
    return `${props.searchConditions.annualSalaryMax}万円`;
  };

  return (
    <div className="pb-4 border-b">
      <div className="py-4 !mb-0 p-side-search-form__section__label">
        希望年収
      </div>
      <div className="flex items-center gap-2">
        {/* 年収下限 */}
        <Select
          value={
            props.searchConditions.annualSalaryMin != null
              ? props.searchConditions.annualSalaryMin.toString()
              : 'none'
          }
          onValueChange={(value) =>
            props.setSearchConditions({
              ...props.searchConditions,
              annualSalaryMin: value === 'none' ? null : Number.parseInt(value),
            })
          }
        >
          <SelectTrigger className="w-40">
            <SelectValue placeholder="下限なし">{getMinLabel()}</SelectValue>
          </SelectTrigger>
          <SelectContent className="w-56">
            <SelectGroup>
              <SelectItem value="none">下限なし</SelectItem>
              {salaryOptions.map((option) => (
                <SelectItem
                  key={`min-salary-${option.value}`}
                  value={option.value}
                >
                  {option.label}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>

        <div className="text-center">〜</div>

        {/* 年収上限 */}
        <Select
          value={
            props.searchConditions.annualSalaryMax != null
              ? props.searchConditions.annualSalaryMax.toString()
              : 'none'
          }
          onValueChange={(value) =>
            props.setSearchConditions({
              ...props.searchConditions,
              annualSalaryMax: value === 'none' ? null : Number.parseInt(value),
            })
          }
        >
          <SelectTrigger className="w-40">
            <SelectValue placeholder="上限なし">{getMaxLabel()}</SelectValue>
          </SelectTrigger>
          <SelectContent className="w-56">
            <SelectGroup>
              <SelectItem value="none">上限なし</SelectItem>
              {salaryOptions.map((option) => (
                <SelectItem
                  key={`max-salary-${option.value}`}
                  value={option.value}
                >
                  {option.label}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
